'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdBorderVertical = function MdBorderVertical(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25 21.6v-3.2h3.4v3.2h-3.4z m0 13.4v-3.4h3.4v3.4h-3.4z m0-26.6v-3.4h3.4v3.4h-3.4z m6.6 6.6v-3.4h3.4v3.4h-3.4z m0-10h3.4v3.4h-3.4v-3.4z m0 16.6v-3.2h3.4v3.2h-3.4z m0 13.4v-3.4h3.4v3.4h-3.4z m-13.2 0v-30h3.2v30h-3.2z m13.2-6.6v-3.4h3.4v3.4h-3.4z m-20-20v-3.4h3.4v3.4h-3.4z m-6.6 20v-3.4h3.4v3.4h-3.4z m0 6.6v-3.4h3.4v3.4h-3.4z m0-13.4v-3.2h3.4v3.2h-3.4z m6.6 0v-3.2h3.4v3.2h-3.4z m0 13.4v-3.4h3.4v3.4h-3.4z m-6.6-26.6v-3.4h3.4v3.4h-3.4z m0 6.6v-3.4h3.4v3.4h-3.4z' })
        )
    );
};

exports.default = MdBorderVertical;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/border-vertical.js
// module id = 2117
// module chunks = 0